module.exports = __webpack_public_path__ + "static/media/USDT-icon.67dc4c56.svg";